/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {

  production: true,
  appname: "Time Verde",
   urlbase: 'https://api-verde.dev.entregadigital.app.br/api/v1/app/',
  //urlbase: "http://localhost/api/v1/app/",

  ds: "&dM4_", // Descryptor Hash

  oneSignalAppID: "",
  oneSignalSafariWebID: "",
  subdomainName: "",



  PSPDFKitKey: "",
  PSPDFKitHost: "",

  version: "1.0.8",
  /**/
};
